import { render, staticRenderFns } from "./AppBtnAgrupados.vue?vue&type=template&id=2cc36e09&scoped=true"
import script from "./AppBtnAgrupados.vue?vue&type=script&lang=js"
export * from "./AppBtnAgrupados.vue?vue&type=script&lang=js"
import style0 from "./AppBtnAgrupados.vue?vue&type=style&index=0&id=2cc36e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc36e09",
  null
  
)

export default component.exports